import { createUseStyles } from "react-jss";
import { colors } from "../../styles/colors";
import { down } from "../../styles/breakpoints";
import {
  pageContentRoot,
  pageHeaderRow,
  pageShellRoot,
} from "../../styles/pageShell";

const useStyles = createUseStyles({
  /* The sidebar shell owns the height; the page only declares padding and
     background. The old `calc(100vh - 60px)` double-counted the mobile top
     bar, so the last rows of the table were unreachable on a phone. */
  contentMain: pageShellRoot,

  containerHeader: {
    ...pageHeaderRow,
    padding: "15px 0px",
  },

  vehiculeRoot: pageContentRoot,

  divApercu: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  divApercuFilter: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "10px",
    [down.sm]: {
      flexDirection: "column",
      alignItems: "stretch",
    },
  },
  divApercu2: {
    display: "flex",
    flexDirection: "row",
    gap: "10px",
    flexWrap: "wrap",
  },

  divFilter: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    /* `min(256px, 100%)` instead of a flat 256px: on a 320px phone the flat
       value plus page padding pushed the filter off-screen. */
    minWidth: "min(256px, 100%)",
    flexWrap: "wrap",
    textWrap: "nowrap",
    gap: "10px",
    "& .MuiTextField-root": {
      minWidth: "inherit",
    },
  },

  divAway: {
    position: "absolute",
    top: 35,
    right: 0,
    left: 0,
    zIndex: "var(--z-sticky-header)",
    width: "min(160px, calc(100vw - 32px))",
    borderRadius: "10px",
    padding: "5px",
    backgroundColor: colors.WHITE,
    boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.10)",
  },
  divAwayCustom: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    borderRadius: "3px",
    padding: "2px 5px 2px 5px",
    gap: "8px",
  },
  divIconArrow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "16px",
  },
});

export default useStyles;
